// eslint-disable-next-line import/no-extraneous-dependencies
import { Route, Routes } from 'react-router-dom';
import App from './App';

export const Router = () => (
	<Routes>
		<Route path="/" element={<App />} />
	</Routes>
);
